import LexiconEntryMatch from './LexiconEntryMatch';

interface Props {
    id: string;
    name: string;
    entryTitleFormatter?: (entry: LexiconEntryMatch) => string;
}

export default class Lexicon {

    public constructor(private readonly props: Props) {
    }

    public getId(): string {
        return this.props.id;
    }

    public getName(): string {
        return this.props.name;
    }

    public formatEntryTitle(entry: LexiconEntryMatch): string {
        return this.props.entryTitleFormatter ? this.props.entryTitleFormatter(entry) : entry.getNumber();
    }
}
